import {CityPublic, EventPublic} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';
import {
    GetEventListResponse,
    GetServiceListResponse,
} from '@yandex-data-ui/cloud-schemas/build/schemas/events/types';

import {request} from 'api';
import {EventsByServiceResponse, GetEventsRequest} from './models';
import {LocaleData} from 'contexts/LocaleContext';

export function getEvents(
    {lang}: LocaleData,
    {city, services, limit, page = 0, preview, past}: GetEventsRequest,
) {
    return request<GetEventListResponse>({
        method: 'GET',
        url: '/api/community/events',
        params: {lang, city, services, limit, page, preview, past},
    });
}

export function getEventsByService({lang}: LocaleData, serviceId?: number) {
    return request<EventsByServiceResponse>({
        method: 'GET',
        url: '/api/community/eventsByService',
        params: {lang, service: serviceId},
    });
}

export function getCities({lang}: LocaleData) {
    return request<CityPublic[]>({
        method: 'GET',
        url: '/api/community/cities',
        params: {lang},
    });
}

export function getServices({lang}: LocaleData) {
    return request<GetServiceListResponse>({
        method: 'GET',
        url: '/api/community/events/services',
        params: {lang},
    });
}

export function getEvent({lang}: LocaleData, id: number) {
    return request<EventPublic>({
        method: 'GET',
        url: `/api/community/events/${id}`,
        params: {lang},
    });
}

export function getSimilar({lang}: LocaleData, id: number) {
    return request({
        method: 'GET',
        url: `/api/community/events/${id}/similar`,
        params: {lang},
    });
}
